module.exports = __webpack_public_path__ + "static/media/quienes-somos.7b8ba53b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/quienes-somos.jpg
// module id = 89
// module chunks = 0